import { useMasterSubjectsSelector } from '../../../redux/selector';
import TreeMenu from '../../common/TreeMenu';
import usePermission from '../../../hooks/usePermission';

export default function QuestionAndAnsser() {
  const subjects = useMasterSubjectsSelector();

  const dataTree = [
    {
      id: 1,
      title: 'Môn học',
      url: `/qna-tickets/tickets/all`,
      children: subjects.map((subject: any) => ({
        id: subject.id,
        title: subject.name,
        url: `/qna-tickets/tickets/${subject?.id}`,
      })),
    },
    {
      id: 2,
      title: 'Góp ý',
      url: '/qna-tickets/feebacks',
      children: [],
    },
    {
      id: 3,
      title: 'Đăng ký sách',
      url: '/qna-tickets/booking-sub',
      children: [],
    },
  ];

  usePermission(['ROLE_ADMIN', 'ROLE_EXPERT', 'ROLE_TEACHER', 'ROLE_CTV']);

  return <TreeMenu dataTree={dataTree} />;
}
